import { render, staticRenderFns } from "./commonTableModal.vue?vue&type=template&id=59a097ea&"
import script from "./commonTableModal.vue?vue&type=script&lang=js&"
export * from "./commonTableModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports